import apiClient from './apiClient';

// In-memory cache for content warnings — the curated vocabulary rarely
// changes but is fetched on library/search pages and author forms. Same
// 5-minute TTL pattern as genresApi/tagsApi.
const WARNINGS_CACHE_TTL_MS = 5 * 60 * 1000;
let warningsCache = null;
let warningsCacheTimestamp = 0;

export const getContentWarnings = async () => {
  const now = Date.now();
  if (warningsCache && (now - warningsCacheTimestamp) < WARNINGS_CACHE_TTL_MS) {
    return warningsCache;
  }
  const response = await apiClient.get('/api/content-warnings');
  warningsCache = response.data;
  warningsCacheTimestamp = now;
  return response.data;
};

// Test helper — clears the in-memory cache so tests start with a clean state.
export const _clearContentWarningsCache = () => {
  warningsCache = null;
  warningsCacheTimestamp = 0;
};

// Moderator/admin: force-set a novel's rating + warnings (or lift the force
// with forced:false). See PUT /api/novels/admin/{id}/content-warnings.
export const updateContentWarnings = async (id, { contentRating, warningIds, note, forced = true, reason } = {}) => {
  const response = await apiClient.put(`/api/novels/admin/${id}/content-warnings`, {
    contentRating,
    warningIds,
    note,
    forced,
    reason,
  });
  return response.data;
};
